export default [
  {
    path: '',
    name: 'stock opname list',
    component: () => import('@/views/app/stock-opname/list/page-list.vue'),
    meta: { title: 'Stock Opname' },
  },
  {
    path: 'scan/:id',
    name: 'stock opname scan',
    component: () => import('@/views/app/stock-opname/scan/page-scan.vue'),
    meta: { title: 'Scan Produk' },
  },
  {
    path: ':id',
    name: 'stock opname detail',
    component: () => import('@/views/app/stock-opname/detail/page-detail.vue'),
    meta: { title: 'Scan Produk' },
  },
]
